const config = {
  apiBaseUrl: "https://cafesero.in/admin/API/",
  baseUrl: "https://cafesero.in/admin/",
};

export default config;
